import React, { useEffect } from 'react';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Button';
import BackArrowsvg from './../../../assets/svg/LeftArrow.svg'
//import {ReactComponent as BackArrowsvg} from './../../../assets/svg/LeftArrow.svg'
import './SelectionModal.css';
import DynamicSearchBar from '../SearchBar';
import CheckboxComponent from '../CheckBox';
//import {ReactComponent as CrossSVG} from './../../../assets/svg_main/CrossIcon.svg'

import CrossSVG from './../../../assets/svg_main/CrossIcon.svg'

interface SelectionModalProps {
    items: any[];
    onSave: (selectedItems: any[],flag:boolean) => void;
    searchPlaceholder: string;
    title: string;
    selectedItemsProps: any[];
}

const SelectionModal: React.FC<SelectionModalProps> = ({ items, onSave, searchPlaceholder, title, selectedItemsProps}) => {
  
    const [selectedItems, setSelectedItems] = useState<any[]>(selectedItemsProps);
    const [selectedAll, setSelectedAll] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState('');
    
    useEffect(() => {
        if (selectedItemsProps.length > 0) {
            setSelectedItems(selectedItemsProps);
        }
    }, [selectedItemsProps]);

    const handleSelectAll = (SelectAllStatus :boolean) =>{
        if(selectedItems?.length < items?.length)
        {
         SelectAllStatus = false;
        }
        if(selectedItems?.length === items?.length)
        {
            SelectAllStatus = true;
        }
        
        if(!SelectAllStatus){
           setSelectedItems(items);
        } else {
            setSelectedItems([]);
        }

    }

    const handleCheckboxChange = (type:string,id: string) => {
     
        let restItem = [];
        if(type==="facility"){
            if(selectedItems?.findIndex((x)=>x.facility_id===id)>-1){

                

                restItem = selectedItems?.filter(obj => obj.facility_id !== id);
                setSelectedItems(restItem);

            } else {
                 restItem = selectedItems?.concat(items?.filter(obj => obj.facility_id == id));
                 setSelectedItems(restItem);
            }
         
        

        } else if(type==="ward"){

            if(selectedItems?.findIndex((x)=>x.ward_id===id)>-1){
                restItem = selectedItems?.filter(obj => obj.ward_id !== id);
                setSelectedItems(restItem);

            } else {

                restItem = selectedItems?.concat(items?.filter(obj => obj.ward_id == id));
                 setSelectedItems(restItem);

            }         

        } else if(type==="village"){

            if(selectedItems?.findIndex((x)=>x.village_id===id)>-1){
                restItem = selectedItems?.filter(obj => obj.village_id !== id);
                setSelectedItems(restItem);

            } else {
                restItem = selectedItems?.concat(items?.filter(obj => obj.village_id == id));
                setSelectedItems(restItem);
            }    

        }
        else if(type==="gram_panchayat"){

            if(selectedItems?.findIndex((x)=>x.gram_panchayat_id===id)>-1){
                restItem = selectedItems?.filter(obj => obj.gram_panchayat_id !== id);
                setSelectedItems(restItem);

            } else {
                restItem = selectedItems?.concat(items?.filter(obj => obj.gram_panchayat_id == id));
                setSelectedItems(restItem);
            }    

        }
        else if(type==="district"){

            if(selectedItems?.findIndex((x)=>x.district_id===id)>-1){
                restItem = selectedItems?.filter(obj => obj.district_id !== id);
                setSelectedItems(restItem);

            } else {
                restItem = selectedItems?.concat(items?.filter(obj => obj.district_id == id));
                setSelectedItems(restItem);
            }    

        }
        
        else {

            restItem=[];  
 
        }
       
        setSelectedItems(restItem);   

    };

    const handleRemoveItem = (type:string,id: string) => {
       let restItem = [];
       if(type==="facility"){
        restItem = selectedItems?.filter(obj => obj.facility_id !== id);
       } else if(type==="ward"){
        restItem = selectedItems?.filter(obj => obj.ward_id !== id);
       } else if(type==="village"){
        restItem = selectedItems?.filter(obj => obj.village_id !== id);
       }
       else if(type==="gram_panchayat"){
        restItem = selectedItems?.filter(obj => obj.gram_panchayat_id !== id);
       }
       else if(type==="district"){
        restItem = selectedItems?.filter(obj => obj.district_id !== id);
       }
       else {

       restItem=[];

       }
       setSelectedItems(restItem);     
    };

    const handleSave = () => {
        if (selectedItems?.length === 0) {
            onSave([], false);
        } else {
            onSave(selectedItems, false);
        }
       
      };

     const [show, setShow] = useState<boolean>(true);
    const handleClose = (): void => {
        onSave([],false);
        setShow(false);
    };
    const handlePrevious = (): void => {
        onSave(selectedItemsProps,false);
        setShow(false);
    };
    
    const handleSearchChange = (value: string) => {
        setSearchTerm(value?.toLowerCase());
    };



    const filteredItems = items?.filter((e)=>{
        if(e.facility_id){
            return(e.facility_name?.toLowerCase().includes(searchTerm));
        } else if(e.ward_id){
            return(e.ward_name?.toLowerCase().includes(searchTerm));
        } else if(e.village_id){
            return(e.village_name?.toLowerCase().includes(searchTerm));
        }
        else if(e.gram_panchayat_id){
            return(e.gram_panchayat_name?.toLowerCase().includes(searchTerm));
        }
        else if(e.district_id){
            return(e.district_name?.toLowerCase().includes(searchTerm));
        }
        else {
            return(<></>)
        }    
    })

    const onCancel=():void=>{
        onSave(selectedItemsProps,false);
        setShow(false);
    }
    
    return items?.length>0?(
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                dialogClassName="custom_modal_page_selection"
            >
                <Modal.Body className="pade_modal_body">
                    <div className="selection-modal-main">
                        <div className="selection-container-modal">
                            <div className="selection_modal_left">
                                <DynamicSearchBar
                                    onChange={handleSearchChange}
                                    placeHolder={searchPlaceholder}
                                    disabled={false}
                                    className=""
                                    iconNeeded={true} />
                                <div className='selection_modal_left_checkbox_label'>
                                <div className='selection_modal_checkbox_label' key={'o'}>
                                            <div>
                                            <CheckboxComponent
                                                    className=""
                                                    isChecked={false}
                                                    disabled={false}
                                                    onCheckboxChange={() => handleSelectAll(selectedAll)}
                                                    placeCheckboxBefore={false}
                                                />                
                                            </div>
                                            <div>
                                                <label className='selection_modal_label_names'>{`${selectedItems?.length === items?.length ? 'Deselect All' : 'Select All'}`}</label>
                                            </div>
                                </div>
{filteredItems?.map((e)=>
    {
        if(e.facility_id){
            return(<div className='selection_modal_checkbox_label' key={e.facility_id}>
            <div>
                <CheckboxComponent
                    className=""
                    isChecked={selectedItems?.findIndex((x)=>x.facility_id===e.facility_id)>-1}
                    disabled={false}
                    onCheckboxChange={() => handleCheckboxChange('facility',e.facility_id)}
                    placeCheckboxBefore={false}
                />
            </div>
            <div>
                <label className='selection_modal_label_names'>{e.facility_name}{e.facility_code?'-'+e.facility_code:''}</label>
            </div>
        </div>);
        } else if(e.ward_id){

            return(<div className='selection_modal_checkbox_label' key={e.ward_id}>
            <div>
                <CheckboxComponent
                    className=""
                    isChecked={selectedItems?.findIndex((x)=>x.ward_id===e.ward_id)>-1}
                    disabled={false}
                    onCheckboxChange={() => handleCheckboxChange('ward',e.ward_id)}
                    placeCheckboxBefore={false}
                />
            </div>
            <div>
                <label className='selection_modal_label_names'>{e.ward_name}{e.ward_code?'-'+e.ward_code:''}</label>
            </div>
        </div>);

        }else if(e.village_id){

            return(<div className='selection_modal_checkbox_label' key={e.village_id}>
            <div>
                <CheckboxComponent
                    className=""
                    isChecked={selectedItems?.findIndex((x)=>x.village_id===e.village_id)>-1}
                    disabled={false}
                    onCheckboxChange={() => handleCheckboxChange('village',e.village_id)}
                    placeCheckboxBefore={false}
                />
            </div>
            <div>
                <label className='selection_modal_label_names'>{e.village_name}{e.village_code?'-'+e.village_code:''}</label>
            </div>
        </div>);

        } 
        else if(e.gram_panchayat_id){

            return(<div className='selection_modal_checkbox_label' key={e.gram_panchayat_id}>
            <div>
                <CheckboxComponent
                    className=""
                    isChecked={selectedItems?.findIndex((x)=>x.gram_panchayat_id===e.gram_panchayat_id)>-1}
                    disabled={false}
                    onCheckboxChange={() => handleCheckboxChange('gram_panchayat',e.gram_panchayat_id)}
                    placeCheckboxBefore={false}
                />
            </div>
            <div>
                <label className='selection_modal_label_names'>{e.gram_panchayat_name}{e.gram_panchayat_code?'-'+e.gram_panchayat_code:''}</label>
            </div>
        </div>);

        } 
        else if(e.district_id){

            return(<div className='selection_modal_checkbox_label' key={e.district_id}>
            <div>
                <CheckboxComponent
                    className=""
                    isChecked={selectedItems?.findIndex((x)=>x.district_id===e.district_id)>-1}
                    disabled={false}
                    onCheckboxChange={() => handleCheckboxChange('district',e.district_id)}
                    placeCheckboxBefore={false}
                />
            </div>
            <div>
                <label className='selection_modal_label_names'>{e.district_name}{e.district_code?'-'+e.district_code:''}</label>
            </div>
        </div>);

        }
        
        else {
            return(<></>);
        }

})}
                               
                               
                                </div>
                            </div>
                            <div className="selection_modal_right">
                                <span className='selection_modal_right_title'>{title} <span style={{color:'#5f5f5f', fontSize:'10px'}}>{`(${selectedItems.length} of ${items.length} selected)`}</span></span>
                                <div className="selected_modal_grid">
        
                                    {selectedItems?.map((e)=>{
                                        if(e.facility_id){
                                            return(<div key={e.facility_id} className="selected_grid_item" title={e.facility_name}>
                                            <span className='selection_modal_right_name'>{e.facility_name}{e.facility_code?'-'+e.facility_code:''}</span>
                                            <Button
                                                onClick={() => handleRemoveItem('facility',e.facility_id)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />
                                        </div>);
                                        } else if(e.ward_id){

                                            return(<div key={e.ward_id} className="selected_grid_item" title={e.ward_name}>
                                            <span className='selection_modal_right_name'>{e.ward_name}{e.ward_code?'-'+e.ward_code:''}</span>
                                            <Button
                                                onClick={() => handleRemoveItem('ward',e.ward_id)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />
                                        </div>);

                                        } else if(e.village_id){
                                            return(<div key={e.village_id} className="selected_grid_item" title={e.village_name}>
                                            <span className='selection_modal_right_name'>{e.village_name}-{e.village_code?'-'+e.village_code:''}</span>
                                            <Button
                                                onClick={() => handleRemoveItem('village',e.village_id)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />
                                        </div>);

                                        }
                                        else if(e.gram_panchayat_id){
                                            return(<div key={e.gram_panchayat_id} className="selected_grid_item" title={e.gram_panchayat_name}>
                                            <span className='selection_modal_right_name'>{e.gram_panchayat_name}-{e.gram_panchayat_code?'-'+e.gram_panchayat_code:''}</span>
                                            <Button
                                                onClick={() => handleRemoveItem('gram_panchayat',e.gram_panchayat_id)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />
                                        </div>);

                                        }
                                        else if(e.district_id){
                                            return(<div key={e.district_id} className="selected_grid_item" title={e.district_name}>
                                            <span className='selection_modal_right_name'>{e.district_name}-{e.district_code?'-'+e.district_code:''}</span>
                                            <Button
                                                onClick={() => handleRemoveItem('district',e.district_id)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />
                                        </div>);

                                        }
                                        else{

                                            return(<><h1>No Data Available</h1></>);

                                        }
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="page_modal_footer">
                    <Button
                        onClick={handlePrevious}
                        disabled={false}
                        id=""
                        buttonName={'previous'}
                        colorType={'previous'}
                        icon={<BackArrowsvg />}
                        iconPosition={'left'}
                    />
                    <div className="page_modal_footer_buttons">
                        <Button
                            onClick={onCancel}
                            disabled={false}
                            id=""
                            buttonName={'Cancel'}
                            colorType={'save'}
                            icon={''}
                            iconPosition={''}
                        />
                        <Button
                            onClick={handleSave}
                            disabled={false}
                            id=""
                            buttonName={'Save'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''}
                        />
                    </div>
                </Modal.Footer>
            </Modal>

        </>
    ):(<></>);
};

export default SelectionModal;